var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFleetShips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M24 14v3c0 3.68-3.533 4.898-3.684 4.948A1.001 1.001 0 0 1 20 22h-8c-.107 0-.214-.018-.316-.052C11.533 21.898 8 20.68 8 17v-3a1 1 0 0 1 .858-.99L10 12.846V9a1 1 0 0 1 1-1h4V7a1 1 0 1 1 2 0v1h4a1 1 0 0 1 1 1v3.846l1.142.164A1 1 0 0 1 24 14zM7.99 9.001a1 1 0 0 1-.848 1.132L2 10.867V13c0 1.933 1.685 2.79 2.186 3H5a1 1 0 1 1 0 2H4c-.107 0-.214-.018-.316-.052C3.533 17.898 0 16.68 0 13v-3a1 1 0 0 1 .858-.99L2 8.847V5a1 1 0 0 1 1-1h4V3a1 1 0 1 1 2 0v1h3a1 1 0 1 1 0 2H4v2.561l2.858-.408a1 1 0 0 1 1.132.848zM22 14.867l-5-.715V17a1 1 0 1 1-2 0v-2.848l-5 .715V17c0 1.933 1.685 2.79 2.186 3h7.628c.495-.208 2.186-1.063 2.186-3v-2.133zm-10-2.306l3.858-.55c.031-.005.061.001.091 0 .018-.002.033-.01.051-.01.018 0 .033.008.051.01.03.001.06-.005.091 0l3.858.55v-2.56h-8v2.56z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40AEC2",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFleetShips);
export default __webpack_public_path__ + "static/media/blue-fleet-ships.4fd4ebd270cb5a8fba1e374b9010da2c.svg";
export { ForwardRef as ReactComponent };